import React from 'react';

import { DesignersDetailsPage, fetchDesignersDetailsData } from 'src/modules/designers';
import { wrapper } from 'src/store';

interface PageDesignersDetailProps {}

const PageDesignersDetail: React.FunctionComponent<PageDesignersDetailProps> = () => (
  <DesignersDetailsPage />
);

export const getServerSideProps = wrapper.getServerSideProps(async ({ params, store }) => {
  const { slug } = params;

  await fetchDesignersDetailsData(slug as string)(store.dispatch);
});

export default PageDesignersDetail;
